



















































































import { Component, Vue } from "vue-property-decorator";
import IndividualTaxationService from "@/services/request/IndividualTaxationService";
import ITRQFilter from "@/dto/request/itrq/ITRQFilter";
import ITRQShortDTO from "@/dto/request/itrq/ITRQShortDTO";
import { ITRQStatus } from "@/constants/request/RequestsStatuses";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import RouteNames from "@/router/RouteNames";
import {processError} from "@/utils/ComponentUtils";
import {debounce} from "typescript-debounce-decorator";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import CreateITRQ from "@/components/request/itrq/CreateITRQ.vue";

@Component({
  components: { PaginationComponent, PortalInput, PortalSelect, CreateITRQ }
})
export default class ITRQList extends Vue {
  public RouteNames = RouteNames;
  public questionnaires: ITRQShortDTO[] = [];
  public totalPages = 0;
  public createMode = false;
  public filter: ITRQFilter = {
    page: 0,
    size: 20,
    customerName: "",
    customerEmail: "",
    status: undefined,
    year: undefined,
    noSubmissionId: false
  };

  get statusOptions(): SelectOption[] {
    const options = Object.values(ITRQStatus).map(s => new SelectOption({ title: s, value: s }));
    return [new SelectOption({ title: "All", value: null }), ...options];
  }

  mounted() {
    this.loadData();
  }

  @debounce(200)
  public loadData() {
    this.$loadOn();
    IndividualTaxationService.getQuestionnaires(this.filter).then(ok => {
      this.questionnaires = ok.data.content;
      this.totalPages = ok.data.totalPages;
      this.$loadOff();
    },
    err => processError(err, this));
  }

  public clearFilter() {
    this.filter = {
      page: 0,
      size: 20,
      customerName: "",
      customerEmail: "",
      status: undefined,
      year: undefined,
      noSubmissionId: false
    };
    this.loadData();
  }

  public changePage(page: number) {
    this.filter.page = page - 1;
    this.loadData();
  }

  public goToQuestionnaire(id: number) {
    this.$router.push({ name: RouteNames.ITRQ, params: { id: id.toString() } });
  }

  public toggleCreateMode() {
    this.createMode = !this.createMode;
  }

  public reload() {
    this.createMode = false;
    this.loadData();
  }
}
